import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {CurrencyFormatter, DateTimeFormatter, PidFormatter} from "../../../utils/formatters";
import {dateFilter, optionFilter} from "../../../utils/filters";

class purchaseList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        let {view, componentConfig, filter, selection, isLoading, namedFilters, searchfield} = this.props;
        if (!filter) {
            filter = [];
        }
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, namedFilters, formId: this.props.formId};
        view = [];
        if (view) {
            props.view = view;
        }
        if (Array.isArray(props.view)) {
            props.view.push("state");
            props.view.push("modifying");
        } else if (props.view instanceof Object) {
            props.view.state = "";
            props.view.modifying = "";
        } else {
            props.view = ["state","modifying"];
        }
        if (this.props.swapList === true) {
            filter.push({field: "state", value: ["513","520"], operator: "between"});
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== false ? (this.props.gridid || "purchaseList") : undefined}
                {...props}
                view={view}
                namedFilters={namedFilters}
                searchfield={searchfield !== undefined ? searchfield : true}
                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel", addFilters: true}]}
                columns={{
                    [componentConfig.idfield]: {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "pid": {
                        header: 'Azonosító',
                        width: 1,
                        sortable,
                        filterable,
                        renderer: PidFormatter,
                    },
                    "partner.name": {
                        header: 'Partner',
                        width: 3,
                        sortable,
                        filterable
                    },
                    "totalprice": {
                        header: 'Végösszeg',
                        width: 1,
                        renderer: CurrencyFormatter,
                        sortable,
                        filterable
                    },
                    "orderdate": {
                        width: 2,
                        header: 'Rögzítés dátuma',
                        sortable,
                        filterable: dateFilter({period: true}),
                        renderer: DateTimeFormatter
                    },
                    "transaction_date": {
                        width: 2,
                        header: 'Elszámolás dátuma',
                        sortable,
                        filterable: dateFilter({period: true}),
                        renderer: DateTimeFormatter
                    },
                    ...(
                        this.props.swapList !== true ? {
                            "StockOperationState.optionlabel": {
                                header: 'Státusz',
                                width: 2,
                                sortable,
                                filterField: 'state',
                                operator: '=',
                                filterable: optionFilter("StockOperationState")
                            },
                        } : {
                            "pos.name": {
                                header: 'Eladási hely (POS)',
                                width: 2,
                                sortable,
                                filterable
                            }
                        }
                    )
                }}
                rowClassName={(rowData) => {
                    return {
                        "warning color": parseInt(rowData.modifying) === 1,
                    };
                }}
                orderBy={{field: "orderdate", direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default purchaseList;
